<script>
export default {
    name: "IconPaymentMaestro"
}
</script>

<template>
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="30px" height="30px" viewBox="570 0 160 120">
        <path d="M655.869 33.2709H626.125V86.7303H655.869V33.2709Z" fill="#7673C0"/>
        <path d="M628.014 60.008C628.003 49.5746 632.792 39.7158 640.998 33.2738C627.06 22.3197 607.046 23.9153 595.02 36.9393C582.993 49.9635 582.993 70.0436 595.02 83.0673C607.046 96.0915 627.06 97.687 640.998 86.7327C632.794 80.2929 628.006 70.4385 628.014 60.008Z" fill="#EB001B"/>
        <path d="M695.99 60.0052C695.987 73.0179 688.557 84.887 676.854 90.5744C665.151 96.2617 651.228 94.769 640.996 86.7299C649.196 80.2847 653.985 70.4314 653.985 60.0002C653.985 49.5697 649.196 39.7164 640.996 33.2711C651.228 25.2262 665.154 23.7301 676.861 29.4181C688.568 35.1063 695.999 46.9793 696 59.9958L695.99 60.0052Z" fill="#00A1DF"/>
    </svg>
</template>

<style scoped lang="scss">

</style>
